import { render, staticRenderFns } from "./list-dije-carrito.vue?vue&type=template&id=691dd6dc"
import script from "./list-dije-carrito.vue?vue&type=script&lang=js"
export * from "./list-dije-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports